import { ProfileInfoDto } from '../../interfaces/profile/profile';

export interface ProfileState {
  profile: ProfileInfoDto | null;
  loading: boolean;
  error: string | null;
}

export const initialProfileState: ProfileState = {
  profile: null,
  loading: false,
  error: null,
};
